<div class="container">

	<div class="portalCard">

		<div class="rowScreenColPhone">

			<div class="aTitle">
				<mat-icon style="vertical-align: middle;">group</mat-icon>
                <span>Mitgliedererstellung</span>
			</div>

            @if( bLoading ) {
                <mat-spinner diameter=30 />
            }

		</div>

		<div>

            @if( bLoading ) {
                <!-- there is a mat-spinner in the first line -->
            }
            @else if( bError ) {
                <div class="errorWarning">
                    Beim Laden der Daten ist ein Fehler aufgetreten
                </div>
            }
            @else {

                <div style="padding: 50px;">
                    <app-member-editor 
                        [sections]="sections"
                        [groups]="groups"
                        (done)="creationDone($event)"
                        [documentExchangeCategories]="documentExchangeCategories"
                        [users]="users"
                        [usernames]="usernames"
                    />
                </div>

            }

        </div>

    </div>

</div>
